import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CpSpeedTestsComponent } from './cp-speed-tests.component';
// import { LocationModule } from '../locations/modules/location/location.module';


@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        // NgxChartsModule,
        // BrowserAnimationsModule,
        // LocationModule
    ],
    declarations: [
        CpSpeedTestsComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class CpSpeedTestsModule {}